import { CatalogItem } from "../../domain/catalogItem";
import { TemplateItem } from "../../domain/catalogTemplate";
import { ActualItem, EstimatedItem, WorkareaItemBase } from "../../domain/workareaItem";
import { FocusedView } from "./ItemsRoot";
import { ItemWorkareaData, ServerState } from "./itemModel";

export const getWorkareaId = (focusedView: FocusedView, focusedWorkareaId: number | undefined, selectedWorkareaId: number | undefined, workareas: ItemWorkareaData[]) => {
  let result: number | undefined
  switch (focusedView) {
    case 'workarea-estimated':
    case 'workarea-actual':
      result = selectedWorkareaId ?? focusedWorkareaId
      break
    default:
      result = selectedWorkareaId
      break
  }

  return result ?? (workareas.length === 1 ? workareas[0].id : undefined)
}

export type Items = {
  estimated: EstimatedItem[],
  actual: ActualItem[],
  added: WorkareaItemBase[],
  catalogItems: CatalogItem[],
  templateItems: TemplateItem[]
}

export const findWorkareaIdForWorkareaItem = (itemGuid: string, items: Items): number => {
  return items.estimated.concat(items.actual).concat(items.added).find(x => x.guid === itemGuid)?.workareaId ?? 0
}

export const getServerState = (workareaId: number, focusedView: FocusedView, items: Items): ServerState => {
  const allWorkareaItems: WorkareaItemBase[] = focusedView === 'workarea-estimated' ? items.estimated : items.actual
  return {
    workareaItems: allWorkareaItems.filter(x => x.workareaId === workareaId),
    catalogItems: items.catalogItems,
    templateItems: items.templateItems
  }
}

export const needsVisitId = (focusedView: FocusedView, visitId?: string): boolean => focusedView === 'visits' && !visitId

export const getNewSortIndex = (workareaId: number, serverState: ServerState, addedItems: WorkareaItemBase[]): number => {
  return serverState.workareaItems.length + addedItems.filter(x => x.workareaId === workareaId).length + 1
}
